<template>
    <tr v-show="expanded">
        <td :colspan="colspan" class="Table__cell--table-expansion">
            <responsive-table :columns="data.columns"
                              :columnFormats="data.columnFormats"
                              :rows="data.rows"
                              :limit-rows="false"
                              v-if="data"
            ></responsive-table>
        </td>
    </tr>
</template>

<script>
    export default {
        data() {
            return {
                expanded: false,
                data: null
            }
        },

        props: {
            rank: {
                type: Number,
                required: true,
            },

            colspan: {
                type: Number,
                required: true,
            },

            name: {
                type: String,
                required: true,
            }
        },

        mounted() {
            bus.$on('load-expanded-table-row', (rank, name, data) => {
                if (this.name == name && this.rank == rank) {
                    this.data = data;
                    this.expanded = true;
                }
            });

            bus.$on('expand-table-row', (rank, name) => {
                if (this.name == name && this.rank == rank) {
                    this.expanded = ! this.expanded;
                }
            });

            bus.$on('filters-updated', () => {
                this.expanded = false;
                this.data = null;
            });
        }
    }
</script>